import React, { useState, useRef, useEffect } from 'react';
import { Dialog, IconButton } from '@material-ui/core';
import useStyles from './styles';
import CloseIcon from '@material-ui/icons/Close';
import Button from '../../../components/Base/Button';
import { iconCloseAdd } from '../../../assets/icons';
import { iconSearch } from '../../../assets/icons';
import { getListShare, shareBrik, listSharedData, unshareBrik } from "actions/brik";
import { useDispatch } from "react-redux";
import { useParams } from 'react-router-dom';
import AppHelper from 'helpers/AppHelper';
import CreateGroup from 'routing/CustomerPage/Customer/CreateGroup';
import InviteMember from 'routing/CustomerPage/Customer/InviteMember';

const ShareBrik = (props: any) => {
  const { brikId, name } = props;
  const styles = useStyles();

  const timeoutID = useRef<any>(null);
  const [keyword, setKeyword] = useState<string>('');
  const [customerInfo, setCustomerInfo] = useState<any>([]);
  const [groupInfo, setGroupInfo] = useState<any>([]);

  const [customerSearched, setCustomerSearched] = useState<any>([]);
  const [groupSearched, setGroupSearched] = useState<any>([]);

  const [saveDataState, setSaveDataState] = useState(true);
  const [showListShared, setShowListShared] = useState<any>([]);

  const dispatch = useDispatch();

  const handleHighlightText = (result: any) => {
    const resultSearch = [];
    for(let i = 0; i < result.length; i++) {
      const id = result[i].id;
      const currentText = result[i].full_name || result[i].email || result[i].name;
      if (currentText) {
        const indexKeyword = currentText.toLowerCase().indexOf(keyword.toLowerCase());
        if (indexKeyword !== -1) {
          const prevText = currentText.slice(0, indexKeyword);
          const hightLightText = currentText.slice(indexKeyword, indexKeyword + keyword.length);
          const nextText = currentText.slice(indexKeyword + keyword.length);
          resultSearch.push({
            id,
            currentText,
            fullName: result[i]?.full_name,
            email: result[i]?.email,
            name: result[i]?.name,
            prevText,
            hightLightText,
            nextText
          })
        } else {
          const indexEmail = result[i].email ? result[i].email?.toLowerCase().indexOf(keyword?.toLowerCase()) : -1;
          if (indexEmail !== -1) {
            const prevText = result[i].email?.slice(0, indexEmail);
            const hightLightText = result[i].email?.slice(indexEmail, indexEmail + keyword.length);
            const nextText = result[i].email?.slice(indexEmail + keyword.length);
            resultSearch.push({
              id,
              currentText: result[i].email,
              fullName: result[i].full_name,
              prevText,
              hightLightText,
              nextText
            })
          }
        }
      }
    }
    return resultSearch;
  }

  useEffect(() => {
    const getListSharedData = async () => {
      const response: any = await dispatch(listSharedData(brikId));
      if (response) {
        const filterCustomer = response.payload.filter((customer: any) => {
          return customer.full_name || customer.email;
        })
        const filterGroup = response.payload.filter((group: any) => {
          return group.name;
        })
        setCustomerSearched(filterCustomer);
        setGroupSearched(filterGroup);
        setShowListShared(response.payload);
      }
    }
    getListSharedData();
  }, [])

  useEffect(() => {
    timeoutID.current = setTimeout(async () => {
      if (keyword.trim() !== '') {
        const listShareData: any = await dispatch(getListShare(brikId, keyword));
        if (listShareData) {
          const customerKeyWordHightlight = handleHighlightText(listShareData.payload.customers);
          //https://briklo.atlassian.net/browse/BP-496
          // const groupKeyWordHightlight = handleHighlightText(listShareData.payload.groups);

          setCustomerInfo(customerKeyWordHightlight);
          //https://briklo.atlassian.net/browse/BP-496
          // setGroupInfo(groupKeyWordHightlight);
        } else {
          setCustomerInfo([]);
          //https://briklo.atlassian.net/browse/BP-496
          // setGroupInfo([]);
        }
      } else {
        setCustomerInfo([]);
        // setGroupInfo([]);
      }
    }, 300);

    return () => {
      clearTimeout(timeoutID.current);
    };
  }, [keyword]);

  const handleCloseModal = () => {
    AppHelper.hideGlobalModal();
  }

  useEffect(() => {
    if (customerSearched.length === 0 && groupSearched.length === 0) {
      setSaveDataState(true);
    }
    const filterCustomer = customerSearched.filter((customer: any) => {
      return customer.customerText ? true : false;
    })
    const filterGroup = groupSearched.filter((group: any) => {
      return group.groupText ? true : false;
    })
    if (filterCustomer.length === 0 && filterGroup.length === 0) {
      setSaveDataState(true);
    }
  }, [customerSearched, groupSearched])

  const handleRemove = async (id: number, type?: string, isSave?: boolean) => {
    if (!isSave) {
      if (type === 'customer') {
        const customerList = customerSearched.filter((customer: any) => {
          return customer.id !== id;
        });
        setCustomerSearched(customerList);
        
        const newListShared = showListShared.filter((item: any) => {
          if (item.id !== id) {
            return item.id !== id;
          } else {
            return item.groupText || item.full_name || item.email || item.name;
          }
        });
        setShowListShared(newListShared);
      } else if (type === 'group') {
        const groupList = groupSearched.filter((group: any) => {
          return group.id !== id;
        });
        setGroupSearched(groupList);
        
        const newListShared = showListShared.filter((item: any) => {
          if (item.id !== id) {
            return item.id !== id;
          } else {
            return item.customerText || item.full_name || item.email || item.name;
          }
        });
        setShowListShared(newListShared);
      }
    } else {
      if (type === 'customer') {
        setSaveDataState(true);
        await dispatch(unshareBrik(brikId, {
          type: 0,
          id
        }));
        setSaveDataState(false);
        const customerList = customerSearched.filter((customer: any) => {
          return customer.id !== id;
        });
        setCustomerSearched(customerList);
  
        const newListShared = showListShared.filter((item: any) => {
          if (item.id !== id) {
            return item.id !== id;
          } else {
            return item.customerText || item.groupText || item.name;
          }
        });
        setShowListShared(newListShared);
      } else if (type === 'group') {
        setSaveDataState(true);
        await dispatch(unshareBrik(brikId, {
          type: 1,
          id
        }));
        setSaveDataState(false);
        const groupList = groupSearched.filter((group: any) => {
          return group.id !== id;
        });
        setGroupSearched(groupList);

        const newListShared = showListShared.filter((item: any) => {
          if (item.id !== id) {
            return item.id !== id;
          } else {
            return item.customerText || item.groupText || item.full_name || item.email;
          }
        });
        setShowListShared(newListShared);
      }
    }
  }

  const handleShareBrik = () => {
    const filterCustomer = customerSearched.filter((customer: any) => {
      return customer.customerText ? true : false;
    })

    const filterGroup = groupSearched.filter((group: any) => {
      return group.groupText ? true : false;
    })

    const inviteCustomer = filterCustomer.map((customer: any) => {
      return {
        id: customer.id,
        type: 0
      }
    })

    const inviteGroup = filterGroup.map((group: any) => {
      return {
        id: group.id,
        type: 1
      }
    })

    const invite = [...inviteCustomer, ...inviteGroup];

    if (invite.length) {
      dispatch(shareBrik(brikId, {
        invite: invite
      }))
    }
    handleCloseModal();
  }

  const [openModalCustomer, setOpenModalCustomer] = useState(false);
  const [openModalGroup, setOpenModalGroup] = useState(false);

  const handleAddNewCustomer = () => {
    setOpenModalCustomer(true);
  };
  
  return (
    <>
    <InviteMember open={openModalCustomer} onCloseModal={() => setOpenModalCustomer(false)} />
    <CreateGroup open={openModalGroup} onCloseModal={() => setOpenModalGroup(false)} />
    <div className={styles.container}>
      <div className={styles.modalContainer}>
          <div className={styles.titleModal}>Share {name}</div>
          <p className={styles.subtitleModal} data-cy='cypress-invite-user-modal'>Once added, they will be able to pay and view this BRIK.</p>
          <IconButton className={styles.closeButton} edge="end" color="inherit" onClick={() => handleCloseModal()} aria-label="close">
              <CloseIcon />
          </IconButton>
      </div>
      <div className={styles.contentModal}>
        <div className={`${styles.contentBodyModal} d-top`}>
        <div className={styles.searchForm}>
        <div className={styles.headTypeSearch}>
            <input 
              type="text" 
              placeholder="Type in customer’s email, name, or group name" 
              value={keyword}
              onChange={e => setKeyword(e.target.value)}
              data-cy='cypress-add-a-user-email'
            />
            {
              keyword ? (
                <CloseIcon className={styles.iconClose} onClick={() => setKeyword("")} />
              ) : (
                <img src={iconSearch} alt="icon" className={styles.iconSearch} />   
              )
            } 
            
          </div>
          {
            keyword && (
              <div className={styles.resultBox}>
              {
                customerInfo.length > 0 && (
                  <>
                    <div className={styles.resultTitle}>Individual Customers</div>
                    <ul className={styles.resultContent}>
                      {
                        customerInfo.map((item: any, index: number) => ( 
                          <li 
                            data-cy="cypress-pick-the-shown-user"
                            key={index} 
                            className={styles.resultText} 
                            onClick={() => {
                              const checkCustomer = customerSearched.find((customer: any) => customer.id === item.id);
                              if (!checkCustomer) {
                                setCustomerSearched([{
                                  id: item.id,
                                  customerText: item.fullName || item.currentText
                                }, ...customerSearched]);
                                setShowListShared([{
                                  id: item.id,
                                  customerText: item.fullName || item.currentText
                                }, ...showListShared]);
                                setSaveDataState(false);
                              }
                              setKeyword('');
                            }}
                          >
                            {
                              item.currentText === item.fullName ? (
                                <span className={styles.textNormal}>
                                  {item.prevText}
                                  <span className={styles.textBold}>{item.hightLightText}</span>
                                  {item.nextText}
                                  {item.email ? ` (${item.email})` : ''}
                                </span>
                              ) : (
                                <span className={styles.textNormal}>
                                  {item.fullName ? item.fullName : ''}
                                  {item.fullName ? ` (` : ''}
                                  {item.prevText}
                                  <span className={styles.textBold}>{item.hightLightText}</span>
                                  {item.nextText}
                                  {item.fullName ? `)` : ''}
                                </span>
                              )
                            }
                          </li>
                        ))
                      }
                    </ul>   
                  </>
                )
              }
              {/* {
                groupInfo.length > 0 && (
                  <>
                    <div className={styles.resultTitle}>Groups</div>
                    <ul className={styles.resultContent}>
                      {
                        groupInfo.map((item: any, index: number) => (
                          <li 
                            key={index} 
                            className={styles.resultText}
                            onClick={() => {
                              const checkGroup = groupSearched.find((group: any) => group.id === item.id);
                              if (!checkGroup) {
                                setGroupSearched([{
                                  id: item.id,
                                  groupText: item.currentText
                                }, ...groupSearched]);
                                setShowListShared([{
                                  id: item.id,
                                  groupText: item.currentText
                                }, ...showListShared]);
                                setSaveDataState(false);
                              }
                              setKeyword('');
                            }}
                          >
                            <span className={styles.textNormal}>
                              {item.prevText}
                              <span className={styles.textBold}>{item.hightLightText}</span>
                              {item.nextText}
                            </span>
                        </li>
                        ))
                      }
                    </ul>
                </>
                )
              } */}
              {
                customerInfo.length === 0 && (
                  <>
                    <div className={styles.textNoResult}>No results found</div>
                    <div className={styles.textAdd} onClick={handleAddNewCustomer}>Add new customer</div>
                    {/* https://briklo.atlassian.net/browse/BP-496 */}
                    {/* <div className={styles.textAdd} onClick={handleAddNewGroup}>Add new group</div> */}
                  </>
                )
              }
            </div>
            )
          }
        </div>
          
          <div className={styles.bodyTypeSearch}>
            {!keyword && showListShared?.map((item: any, index: number) => (
              <div className={styles.addItem} key={index}>
                {item.customerText || item.groupText || item.full_name || item.email || item.name}
                <span className={styles.iconCloseAdd} onClick={() => {
                  if (item.customerText) {
                    handleRemove(item.id, 'customer', false);
                  } else if (item.groupText) {
                    handleRemove(item.id, 'group', false);
                  } else if (item.full_name || item.email) {
                    handleRemove(item.id, 'customer', true);
                  } else if (item.name) {
                    handleRemove(item.id, 'group', true);
                  }
                }}>
                  <img src={iconCloseAdd} alt="icon" />
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.modalFooter}>
        <span onClick={handleCloseModal}>Cancel</span>
        <div className={`${styles.btnCreateNew} d-inline-block`}>
          <Button type='button' label='Save' disabled={saveDataState} onClick={handleShareBrik} data-cy="cypress-save-invite-user"></Button>
        </div>
      </div> 
    </div> 
    </>
  )
}

export default ShareBrik;